<template>
  <div class="mobile-comment-block-container">
    <div class="table-title">
      <div class="title-left">
        <i class="el-icon-s-management" />会签意见
      </div>
    </div>    
    <div class="time-line-content" v-if="commentList.length > 0">
      <el-timeline>
        <template v-for="(item, i) in commentList">
          <el-timeline-item v-if="!item.isEdit" :key="i" :timestamp="item.time" placement="top">
            <template v-for="(comment, num) in item.comments">
              <!-- 若为当前经办人， 显示评论框 -->
              <el-card class="time-stamp" shadow="hover" :key="num">
                <div class="title-line">
                  <div class="title-line-left">
                    <div class="comment-name">{{comment.assigneeName}} <span class="assignee-dept">{{comment.historyActivityName}}</span></div>
                    <!-- <span class="comment-position">{{comment.job}}</span> -->
                  </div>
                  <div class="title-line-right">{{comment.comments[0].time}}</div>
                </div>
                <div class="time-stamp-content content-first" v-if="comment.attachments.length>0">{{comment.attachments[0].description}}</div>
                <div class="time-stamp-content content-first" v-else>{{comment.comments[0].message}}</div>

                <!-- 附件 -->
                <div class="file-upload" v-if="comment.attachments.length>0">
                  <div class="file-container">
                    <div class="left-title">附件：</div>
                  </div>
                  <div class="right-content">
                    <template v-for="item in comment.attachments">
                      <div :key="`${item.id}${item.time}`">
                        <a target="_blank" :href="item.url">{{item.name}}</a>
                      </div>
                    </template>
                  </div>
                  <!-- <a :href="comment.attachments[0].url">附件：{{comment.attachments[0].name}}</a> -->
                </div>

              </el-card>
            </template>
          </el-timeline-item>
        </template>
      </el-timeline>
    </div>

    <el-input
      class="form-content"
      type="textarea"
      placeholder="请输入会签意见"
      v-model="submitText"
      maxlength="100"
      rows="4"
      v-if="status=='todo'"
    >
    </el-input>
  </div>
</template>
<script>
export default {
  name: "MobileCommentBlock",
  data() {
    return  {
      submitText: ''
    }
  },
  props: {
    commentList: {
      type: Array,
      default: ()=> {
        return []
      }
    },
    // done 或 todo
    status: {
      type: String,
      default: 'done'
    }
  },  
  mounted() {

  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.mobile-comment-block-container{
  padding: .25rem .3rem;
  /deep/ .el-timeline {
    padding-left: .3rem;
  }
  /deep/ .el-timeline-item {
    // margin-top: .25rem;
    .el-timeline-item__node{
      background-color: #fff;
      border: 2px solid #409eff; 
      width: 0.25rem;
      height: 0.25rem;
      top: 0rem;
      left: 0;
    }
  }
  /deep/ .el-timeline-item__wrapper{
    padding-left: 0;
    .el-timeline-item__timestamp.is-top{
      padding-left: .4rem;
      font-size: 0.38rem;
    }
  }

  /deep/ .el-card{
    border-radius: 0.2rem;
    margin-bottom: 0.2rem;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05);   
  }

  // /deep/ .el-timeline-item{
  //   padding-bottom: 10px !important;
  // }

  .table-title{
    width: 100%;
    // height: 1rem;
    line-height: 1rem;
    margin-top: .2rem;
    // padding-left: .3rem;
    // padding-right: .3rem;
    .title-left{
      font-size: 0.38rem;
      color: #666;
      font-weight: 600;
    }
  }

  .time-stamp{
    margin-bottom: 10px;
    .title-line{
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .title-line-left{
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        .comment-name{
          font-size: 0.38rem;
          font-weight: 400;
          color: #666666;
          padding-right: 5px;
          .assignee-dept{
            color: #999;
            font-size: 0.38rem;
          }
        }
        .comment-position{
          font-weight: 400;
          font-size: 0.38rem;
          color: #999999;
        }
      }
      .title-line-right{
        font-weight: 400;
        font-style: normal;
        font-size: 0.38rem;
        color: #999999;
      }
    }
    .time-stamp-content{
      color: #333;
      font-weight: 400;
      font-style: normal;
      font-size: 0.38rem;
      text-align: left;
      line-height: 20px;
      .comment-tip{
        color:#3379CC;
      }
    }
    .content-first{
      margin-top: 8px;
    }
    .file-upload{
      margin-top: 5px;
      display: flex;
      justify-content: flex-start;
      align-content: center;
      .left-title{
        // width: 40px;
        color: #333;
        font-weight: 400;
        font-style: normal;
        font-size: 0.38rem;        
      }
      .right-content{
        flex: 1;
      }
      a{
        color: #333;
        font-weight: 400;
        font-style: normal;
        font-size: 0.38rem;
      }
      a:hover{
        color: #409EFF;
      }
    }
    .timeline-title{
      font-weight: 400;
      font-size: 0.38rem;
      line-height: 32px;
    }
    .opinion-content{
      margin-bottom: 10px;
    }
  }  
}
</style>